import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "./custom-slice";

export const apiSlice = createApi({
	reducerPath: "apiSlice",
	baseQuery: customBaseQuery,
	tagTypes: [
		"CustomerDashboard",
		"SolarProviderInformation",
		"SolarProducts",
		"Orders",
		"CustomerOrders",
		"Transactions",
		"CustomerInfo",
		"ProductCategory",
		"RoofTypes",
		"Wishlist",
		"DeliveryAddress",
		"CustomerCards",
		"ApplianceCategory",
	],
	endpoints: builder => ({}),
});
